import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";

// Register service worker for offline support
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker?.register('/sw.js')?.then((registration) => {
        // When a new service worker is waiting, activate it immediately
        // so the updated cache (with new asset hashes) takes effect.
        registration?.addEventListener('updatefound', () => {
          const newWorker = registration?.installing;
          if (!newWorker) return;
          newWorker?.addEventListener('statechange', () => {
            if (
              newWorker?.state === 'installed' &&
              navigator.serviceWorker?.controller
            ) {
              // Tell the new SW to skip waiting and take control
              newWorker?.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      })?.catch((err) => {
        console.warn('Service worker registration failed:', err);
      });
  });
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<App />);
